<script setup>
import { nextTick } from 'vue';

// --------------------------------- Imports -------------------------------- //

// ---------------------------------- Props --------------------------------- //
const props = defineProps({
  columnConfig: {
    type: Object,
    default: () => ({}),
  },
  componentConfig: {
    type: Object,
    default: () => ({}),
  },
  filterConfig: {
    type: Object,
    default: () => ({}),
  },
  formElements: {
    type: Object,
    default: () => ({}),
  },
});
// ---------------------------------- Emits --------------------------------- //

// ---------------------------- Injects/Provides ---------------------------- //

// ----------------------- Variables - Pinia - consts ----------------------- //

// --------------------- Variables - Pinia - storeToRefs -------------------- //

// ------------------- Variables - Local - consts and lets ------------------ //

// ------------------------ Variables - Local - refs ------------------------ //

// ---------------------- Variables - Local - reactives --------------------- //

// --------------------------- Computed properties -------------------------- //

// -------------------------------- Functions ------------------------------- //

// -------------------------------- Watchers -------------------------------- //

// ----------------------------- Lifecycle Hooks ---------------------------- //
onMounted(() => {
  nextTick(() => {
    props.formElements.operator_value_min?.input?.focus();
  });
});
</script>

<template>
  <div class="flex gap-4">
    <TextElement
      autocomplete="off"
      name="operator_value_min"
      :default="filterConfig?.operator_value_min || null"
      input-type="number"
      class="w-full"
      :placeholder="$t('Min')"
    />
    <TextElement
      autocomplete="off"
      name="operator_value_max"
      :default="filterConfig?.operator_value_max || null"
      input-type="number"
      class="w-full"
      :placeholder="$t('Max')"
    />
  </div>
</template>
